export default __webpack_public_path__ + "static/media/courosLogo.84205846.jpeg";